import React, { useCallback, useEffect, useRef, useState } from "react";
import { WithPermission } from "@components/Auth/withPermission";
import CreateCommonComponent from "@components/common/CreateComponent";
import { useNavigate } from "react-router-dom";
import { NAV_ITEMS_MODAL, session_message, session_form_details, session_form_state } from "@constants/sessionSiteConstant";
import SessionForm from "../sessionForm/sessionForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { setCreateMapPincodeWithHfr, setGeometryMapPoint, setMapLatLong, setMapManualAddress, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setMapServicesCreatePolygon, setMapServicesDown, setMapServicesPolygonForEdit } from "@store/actions/facilityGeoMapAction";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import { toast } from 'react-toastify';
import { formStateType, vhndUhndProps } from "../vhnd-interface";
import dayjs from "dayjs";
import { createSessionApi, getHealthProviderByFacilitySessionSiteApi, getMobiliserByFacilitySessionSiteApi, getSessionHeldAtSessionSiteApi, getSessionTypeSessionSiteApi, getUserLocationFacilityApi, getVillageCoverageSessionSiteApi, getWardCoverageSessionSiteApi } from "../sessionServices";
import { map_message } from "@constants/esriMapConstant";
import { dateFormate } from "@constants/index";
import config from "@config/config";

const CreateVhndUhnd = ({ page, flow }: vhndUhndProps) => {

    // code for map
    const dispatch = useDispatch();
    const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);

    const clearMapStore = () => {
        dispatch(setGeometryMapPoint({ mapPointer: '', distFenceGeometry: '' }));
        dispatch(setMapManualAddress(false));
        dispatch(setMapLatLong(null));
        dispatch(setMapManualLatLong(false));
        dispatch(setMapManualLatLongClicked(false));
        dispatch(setMapPincodeFirstTimeEdit(null));
        dispatch(setCreateMapPincodeWithHfr(null))
        dispatch(setMapServicesDown(false));
        dispatch(setMapServicesCreatePolygon(false));
        dispatch(setMapServicesPolygonForEdit(false));
    }
    //====================
    const navItemsModal = NAV_ITEMS_MODAL;
    const [formCompleted, setFormCompleted] = useState<boolean[]>(
        Array(navItemsModal.length).fill(false),
    );
    const [closeModal, setCloseModal] = useState<boolean>(false)
    const navigate = useNavigate();

    const [sessionDetailsFormData, setSessionDetailsFormData] = useState<any>(JSON.parse(JSON.stringify(session_form_details)));
    const [sessionDetailsFormState, setsessionDetailsFormState] = useState<formStateType>(JSON.parse(JSON.stringify(session_form_state)));
    const userLocationDetailsRef = useRef<any>('');
    const sessionHeldAtRef = useRef<any[]>([]);
    const [showLoader, setShowLoader] = useState<boolean>(true);
    const sesssionDateRef = useRef<any>('');

    const getHealthProviderByFacilitySessionSite = async (facilityId: any, date: any) => {
        const res = await getHealthProviderByFacilitySessionSiteApi(facilityId, date);
        if (res) {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                hpTagged: {
                    ...create_sessionDetails.hpTagged,
                    '#options': res.data.map((key: any) => {
                        return {
                            value: `${key?.f_name} ${key?.l_name}`,
                            label: `${key?.f_name} ${key?.l_name}`,
                            id: key?.user_id,
                            code: `${key?.user_code}_${key?.uf_tagged_id}`
                        }
                    })
                }
            }));
        }
    };

    const getMobiliserByFacilitySessionSite = async (hpTaggedData: any, hptaggedOption: any, date: any) => {
        const mobilizerIdArray = hptaggedOption.filter((ele: any) => hpTaggedData.includes(ele.value)).map((ele: any) => {
            return ele.code.split('_')[1];
        });

        const res = await getMobiliserByFacilitySessionSiteApi(mobilizerIdArray, date);
        if (res) {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                mobiliserTagged: {
                    ...create_sessionDetails.mobiliserTagged,
                    '#options': res.data.map((key: any) => {
                        return {
                            value: `${key?.f_name} ${key?.l_name}`,
                            label: `${key?.f_name} ${key?.l_name}`,
                            id: key?.mobiliser_id,
                            code: key?.mobiliser_id
                        }
                    })
                }
            }));
        }
    };

    const getVillageCoverageSessionSite = async (facilityId: any) => {
        const res = await getVillageCoverageSessionSiteApi(facilityId);
        if (res) {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                vilagesCovered: {
                    ...create_sessionDetails.vilagesCovered,
                    '#options': res.data.map((key: any) => {
                        return {
                            value: key?.village_name,
                            label: key?.village_name,
                            id: key?.village_id,
                            code: key?.village_code
                        }
                    })
                }
            }));
        }
    };

    const getWardCoverageSessionSite = async (facilityId: any) => {
        const res = await getWardCoverageSessionSiteApi(facilityId);
        if (res) {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                wardsCovered: {
                    ...create_sessionDetails.wardsCovered,
                    '#options': res.data.map((key: any) => {
                        return {
                            value: key?.ward_name,
                            label: key?.ward_name,
                            id: key?.ward_id,
                            code: key?.ward_code
                        }
                    })
                }
            }));
        }
    };

    const getUserLocationFacility = async () => {
        setShowLoader(true);
        const res = await getUserLocationFacilityApi();
        if (res) {
            userLocationDetailsRef.current = res.data;
            res.data.facility_id ? getVillageCoverageSessionSite(res.data.facility_id) : '';
            res.data.facility_id ? getWardCoverageSessionSite(res.data.facility_id) : '';
            setShowLoader(false);
        }
    };

    const getSessionTypeSessionSite = async () => {
        const res = await getSessionTypeSessionSiteApi();
        if (res) {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                sessionType: {
                    ...create_sessionDetails.sessionType,
                    '#options': res.data.map((key: any) => {
                        return {
                            value: key?.session_type_name,
                            label: key?.session_type_name,
                            id: key?.session_type_id,
                            code: key?.session_type_code
                        }
                    })
                }
            }));
        }
    };

    const getSessionHeldAtSessionSite = async () => {
        const res = await getSessionHeldAtSessionSiteApi();
        if (res) {
            sessionHeldAtRef.current = res.data.map((key: any) => {
                return {
                    value: key?.session_held_at_name,
                    label: key?.session_held_at_name,
                    id: key?.session_held_at_id,
                    code: key?.session_held_at_code
                }
            });
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                sessionHeldAt: {
                    ...create_sessionDetails.sessionHeldAt,
                    '#options': sessionHeldAtRef.current
                }
            }));
        }
    };

    useEffect(() => {
        getUserLocationFacility();
        getSessionTypeSessionSite();
        getSessionHeldAtSessionSite();
    }, []);

    const handleSessionDetailsDataChangeOnMapFails = useCallback((data: any) => {
        setSessionDetailsFormData((prevState: any) => ({
            ...prevState,
            sessionSiteCoverageArea: {
                ...prevState.sessionSiteCoverageArea,
                '#isDisabled': data ? data : false,
            }
        }));
    }, []);

    const handSessionHeldChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
        if (value) {
            setsessionDetailsFormState((prevState: any) => ({
                ...prevState,
                [key]: {
                    ...prevState[key],
                    value: value,
                    id: id,
                    code: code,
                    option: option,
                    isError: false,
                    message: '',
                },
                sessionHeldAt: {
                    ...prevState.sessionHeldAt,
                    value: userLocationDetailsRef.current?.facility_name,
                    id: userLocationDetailsRef.current?.facility_id,
                    code: userLocationDetailsRef.current?.facility_id,
                    option: [{
                        value: userLocationDetailsRef.current?.facility_name,
                        label: userLocationDetailsRef.current?.facility_name,
                        id: userLocationDetailsRef.current?.facility_id,
                        code: userLocationDetailsRef.current?.facility_id
                    }],
                    isError: false,
                    message: '',
                }
            }));
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                sessionHeldAt: {
                    ...create_sessionDetails.sessionHeldAt,
                    '#isDisabled': true,
                    '#options': [{
                        value: userLocationDetailsRef.current?.facility_name,
                        label: userLocationDetailsRef.current?.facility_name,
                        id: userLocationDetailsRef.current?.facility_id,
                        code: userLocationDetailsRef.current?.facility_id
                    }]
                },
                sessionSiteAddress: {
                    ...create_sessionDetails.sessionSiteAddress,
                    '#isDisabled': true
                }
            }));
        } else {
            setsessionDetailsFormState((prevState: any) => ({
                ...prevState,
                [key]: {
                    ...prevState[key],
                    value: value,
                    id: id,
                    code: code,
                    option: option,
                    isError: false,
                    message: '',
                },
                sessionHeldAt: {
                    ...prevState.sessionHeldAt,
                    value: '',
                    id: '',
                    code: '',
                    option: [],
                    isError: false,
                    message: '',
                }
            }));
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                sessionHeldAt: {
                    ...create_sessionDetails.sessionHeldAt,
                    '#isDisabled': false,
                    '#options': sessionHeldAtRef.current
                },
                sessionSiteAddress: {
                    ...create_sessionDetails.sessionSiteAddress,
                    '#isDisabled': false
                }
            }));
        }
    }, []);

    const handleHpTaggedChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
        setsessionDetailsFormState((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                id: id,
                code: code,
                option: option,
                isError: false,
                message: '',
            },
            mobiliserTagged: {
                ...prevState.mobiliserTagged,
                value: '',
                id: '',
                code: '',
                option: '',
                isError: false,
                message: '',
            },
        }));
        if (value && value.length > 0) {
            getMobiliserByFacilitySessionSite(JSON.parse(JSON.stringify(value)), JSON.parse(JSON.stringify(option)), sesssionDateRef.current)
        } else {
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                mobiliserTagged: {
                    ...create_sessionDetails.mobiliserTagged,
                    '#options': []
                }
            }));
        }
    }, []);

    const handleSessionDataChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
        setsessionDetailsFormState((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                id: id,
                code: code,
                option: option,
                isError: false,
                message: '',
            },
            hpTagged: {
                ...prevState.hpTagged,
                value: '',
                isError: false,
                message: '',
            },
            mobiliserTagged: {
                ...prevState.mobiliserTagged,
                value: '',
                isError: false,
                message: '',
            },
        }));
        if (value) {
            sesssionDateRef.current = dayjs(value).format(dateFormate.yyyy_mm_dd);
            getHealthProviderByFacilitySessionSite(userLocationDetailsRef.current?.facility_id, sesssionDateRef.current);
        } else {
            sesssionDateRef.current = '';
            setSessionDetailsFormData((create_sessionDetails: any) => ({
                ...create_sessionDetails,
                hpTagged: {
                    ...create_sessionDetails.hpTagged,
                    '#options': []
                },
                mobiliserTagged: {
                    ...create_sessionDetails.mobiliserTagged,
                    '#options': []
                }
            }));
        }
    }, []);

    const handleSessionDetailsFormChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
        setFormCompleted([false]);
        if (key == 'sessionHeld') {
            handSessionHeldChange(value, key, id, option, code);
        } else if (key == 'sessionDate') {
            handleSessionDataChange(value, key, id, option, code);
        } else if (key == 'hpTagged') {
            handleHpTaggedChange(value, key, id, option, code);
        } else {
            setsessionDetailsFormState((prevState: any) => ({
                ...prevState,
                [key]: {
                    ...prevState[key],
                    value: value,
                    id: id,
                    code: code,
                    option: option,
                    isError: false,
                    message: '',
                },
            }));
        }
    }, []);

    const handleSessionDetailsCoverageArea = useCallback((value: any, key: any) => {
        setFormCompleted([false]);
        setsessionDetailsFormState((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
            },
        }));
    }, []);

    const handleSessionDetailsError = useCallback((value: any, key: string) => {
        setsessionDetailsFormState((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                ...value
            },
        }));
    }, []);

    const contents = [
        <>
            <SessionForm formData={sessionDetailsFormData} formState={sessionDetailsFormState} handleFormChange={handleSessionDetailsFormChange} handleSessionDetailsError={handleSessionDetailsError} handleSessionDetailsDataChangeOnMapFails={handleSessionDetailsDataChangeOnMapFails} userLocationDetails={userLocationDetailsRef.current} handleSessionDetailsCoverageArea={handleSessionDetailsCoverageArea} flow={flow} />
        </>
    ];

    const CloseFacility = () => {
        setCloseModal(true);
    };

    const closeCreateModal = (value: boolean) => {
        if (value) {
            setCloseModal(false);
            clearMapStore();
            navigate(`/VHND`);
        }
        else {
            setCloseModal(false);
        }
    };

    const checkFormValid = () => {
        const sessionDetailsTempChange = JSON.parse(JSON.stringify(sessionDetailsFormState));
        let isFormError = false;
        Object.keys(sessionDetailsTempChange).map((item) => {
            if (item === 'sessionType') {
                if (!sessionDetailsTempChange.sessionType.value) {
                    sessionDetailsTempChange.sessionType.isError = true;
                    sessionDetailsTempChange.sessionType.message = session_message.sessionType.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.sessionType.isError = false;
                }
            } else if (item === 'sessionName') {
                if (!sessionDetailsTempChange.sessionName.value) {
                    sessionDetailsTempChange.sessionName.isError = true;
                    sessionDetailsTempChange.sessionName.message = session_message.sessionName.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.sessionName.isError = false;
                }
            } else if (item === 'sessionDate') {
                if (!sessionDetailsTempChange.sessionDate.value) {
                    sessionDetailsTempChange.sessionDate.isError = true;
                    sessionDetailsTempChange.sessionDate.message = session_message.sessionDate.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.sessionDate.isError = false;
                }
            } else if (item === 'sessionHeldAt') {
                if (!sessionDetailsTempChange.sessionHeldAt.value) {
                    sessionDetailsTempChange.sessionHeldAt.isError = true;
                    sessionDetailsTempChange.sessionHeldAt.message = session_message.sessionHeldAt.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.sessionHeldAt.isError = false;
                }
            } else if (item === 'sessionSiteAddress') {
                if (!sessionDetailsTempChange.sessionSiteAddress.value) {
                    sessionDetailsTempChange.sessionSiteAddress.isError = true;
                    sessionDetailsTempChange.sessionSiteAddress.message = session_message.sessionSiteAddress.message;
                    isFormError = true;
                } else {
                    if (sessionDetailsTempChange.lattitude.value && sessionDetailsTempChange.longitude.value) {
                        sessionDetailsTempChange.sessionSiteAddress.isError = false;
                    } else {
                        sessionDetailsTempChange.sessionSiteAddress.isError = true;
                        sessionDetailsTempChange.sessionSiteAddress.message = session_message.sessionSiteAddress.messageForSuggestion;
                        isFormError = true;
                    }
                }
            } else if (item === 'hpTagged') {
                if (!sessionDetailsTempChange.hpTagged.value.length || sessionDetailsTempChange.hpTagged.value.length.length == 0) {
                    sessionDetailsTempChange.hpTagged.isError = true;
                    sessionDetailsTempChange.hpTagged.message = session_message.hpTagged.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.hpTagged.isError = false;
                }
            } else if (item === 'mobiliserTagged') {
                if ((!sessionDetailsTempChange.mobiliserTagged.value || sessionDetailsTempChange.mobiliserTagged.value.length == 0) && sessionDetailsFormData.mobiliserTagged['#required'] === true) {
                    sessionDetailsTempChange.mobiliserTagged.isError = true;
                    sessionDetailsTempChange.mobiliserTagged.message = session_message.mobiliserTagged.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.mobiliserTagged.isError = false;
                }
            } else if (item === 'vilagesCovered') {
                if ((!sessionDetailsTempChange.vilagesCovered.value || sessionDetailsTempChange.vilagesCovered.value.length.length == 0) && sessionDetailsFormData.vilagesCovered['#required'] === true) {
                    sessionDetailsTempChange.vilagesCovered.isError = true;
                    sessionDetailsTempChange.vilagesCovered.message = session_message.vilagesCovered.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.vilagesCovered.isError = false;
                }
            } else if (item === 'wardsCovered') {
                if ((!sessionDetailsTempChange.wardsCovered.value || sessionDetailsTempChange.wardsCovered.value.length.length == 0) && sessionDetailsFormData.wardsCovered['#required'] === true) {
                    sessionDetailsTempChange.wardsCovered.isError = true;
                    sessionDetailsTempChange.wardsCovered.message = session_message.wardsCovered.message;
                    isFormError = true;
                } else {
                    sessionDetailsTempChange.wardsCovered.isError = false;
                }
            } else if (item === 'coverageArea') {
                if (!facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
                    if (!sessionDetailsTempChange.coverageArea.value || sessionDetailsTempChange.coverageArea.value.length == 0) {
                        sessionDetailsTempChange.coverageArea.isError = true;
                        sessionDetailsTempChange.coverageArea.message = session_message.sessionSiteCoverageArea.message;
                        isFormError = true;
                    } else {
                        if (!facilityGeoMap.createPolygone) {
                            sessionDetailsTempChange.coverageArea.isError = true;
                            sessionDetailsTempChange.coverageArea.message = session_message.sessionSiteCoverageArea.message2;
                            isFormError = true;
                        } else {
                            sessionDetailsTempChange.coverageArea.isError = false;
                        }
                    }
                }
            }
        });

        setsessionDetailsFormState(sessionDetailsTempChange);

        return isFormError
    };

    const handleSave = (): void => {
        const isFormError = checkFormValid();

        if (!isFormError) {
            if (!facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
                if ((facilityGeoMap.distFenceGeometry && facilityGeoMap.mapPointer) && !geometryEngine.contains(facilityGeoMap.distFenceGeometry, facilityGeoMap.mapPointer)) {
                    toast.error(map_message.sessionGeometryMessage, {
                        position: "top-center",
                    });

                    return;
                }
            }
        }
        setFormCompleted([!isFormError]);
    };

    const handleArrayIds = (data: any) => {
        const idArray = data.option.filter((ele: any) => data.value.includes(ele.value)).map((ele: any) => {
            return ele.id;
        });

        return idArray;
    }

    const finishHandler = async () => {
        const payLoad = {
            "sessionTypeId": sessionDetailsFormState.sessionType?.id ? sessionDetailsFormState.sessionType?.id : '',
            "sessionName": sessionDetailsFormState.sessionName?.value ? sessionDetailsFormState.sessionName?.value : '',
            "sessionPlannedDate": sessionDetailsFormState.sessionDate?.value ? dayjs(sessionDetailsFormState.sessionDate?.value).format(dateFormate.yyyy_mm_dd) : '',
            "isSessionHeldAtFacility": sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeld?.value : false,
            "sessionLat": sessionDetailsFormState.lattitude?.value ? sessionDetailsFormState.lattitude?.value : '',
            "sessionLong": sessionDetailsFormState.longitude?.value ? sessionDetailsFormState.longitude?.value : '',
            "facilityId": sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeldAt?.id ? sessionDetailsFormState.sessionHeldAt?.id : null : null,
            "temporarySessionHeldAtId": !sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeldAt?.id ? sessionDetailsFormState.sessionHeldAt?.id : null : null,
            "sessionSiteAddress": sessionDetailsFormState.sessionSiteAddress?.value ? sessionDetailsFormState.sessionSiteAddress?.value : '',
            "healthProviderTaggedIds": sessionDetailsFormState.hpTagged?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.hpTagged))) : [],
            "mobileUserTaggedIds": sessionDetailsFormState.mobiliserTagged?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.mobiliserTagged))) : [],
            "villageCoverageIds": sessionDetailsFormState.vilagesCovered?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.vilagesCovered))) : [],
            "wardCoverageIds": sessionDetailsFormState.wardsCovered?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.wardsCovered))) : [],
            "coverageDetails": sessionDetailsFormState.coverageArea?.value.length > 0 ? sessionDetailsFormState.coverageArea?.value.map((ele: any) => {
                return {
                    "area_name": ele.address,
                    "area_latlong": ele.locationDetail
                }
            }) : []
        };

        const response: any = await createSessionApi(payLoad);
        if (response) {
            toast.success(session_message.sessionCreationSuccessMessage, {
                position: 'top-center',
            });
            clearMapStore();
            navigate(`/VHND`);
        }
    };

    const handleSubmit = (): void => {
        handleSave();
    };

    const onHandleBackArrowButton = () => {
        navigate(`/VHND`);
        clearMapStore();
    };

    const breadcrumbItemName = [
        { value: page, label: 'Geographical Entities' },
        { value: page, label: 'Session Site' },
    ];

    return <>
        <WithPermission moduleCode="GeoNG_VHNDUHND" pageCode='GeoNG_VHNDUHND_CrPg' privilege="create">
            <CreateCommonComponent
                breadcrumbItemName={breadcrumbItemName}
                onHandleBackArrowButton={onHandleBackArrowButton}
                navItemsModal={navItemsModal}
                activeIndex={0}
                formCompleted={formCompleted}
                headerName={"Create a new session"}
                contents={(!showLoader && userLocationDetailsRef.current) ? contents : [<><div className='loader'>Loading...</div></>]}
                handleSubmit={handleSubmit}
                finishHandler={finishHandler}
                handleCancel={CloseFacility}
                closeCreateModal={closeCreateModal}
                closeModal={closeModal} />
        </WithPermission>
    </>
}
export default CreateVhndUhnd;